const getGlobalStyleSheets = () => {
  const styleSheetList = document.styleSheets;
  const viteStyleSheets = Array.from(styleSheetList).filter((styleSheet, index) => {
    const { ownerNode } = styleSheet;
    const isHtmlElement = ownerNode?.nodeType === 1;
    if (!ownerNode || !isHtmlElement) {
      return false;
    }
    const isViteStyle = (ownerNode as HTMLElement).hasAttribute('data-vite-dev-id');
    if (isViteStyle) {
      document.styleSheets[index].disabled = true;
    }
    return isViteStyle;
  });
  const globalSheets = viteStyleSheets.map((styleSheet) => {
    const sheet = new CSSStyleSheet();
    const css = Array.from(styleSheet.cssRules)
      .map((rule) => rule.cssText)
      .join(' ');
    sheet.replaceSync(css);
    return sheet;
  });

  return globalSheets;
};

export default getGlobalStyleSheets;
